var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center mt-4"},_vm._l((_vm.steps),function(step,index){return _c('span',{key:index,class:[
      'notification-step-item',
      step === _vm.currentStep ? 'notification-step-item-selected' : '',
    ]})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }